import React from "react";
import { Modal, Form } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createLocation, createSongs } from "../../Redux/Actions/songs";
import { toast } from "react-toastify";

const CreateLocationModal = ({ show, handleClose, selectedLocation, Initialize }) => {
    const dispatch = useDispatch()
    const initialValues = {
        name: "",
        cityName: ""
    };

    const validationSchema = Yup.object({
        name: Yup.string().trim().required("Location name is required"),
        cityName: Yup.string().trim().required("City name is required"),
    });

    const handleSubmit = (values) => {
        values['active'] = true
        dispatch(createLocation(values)).then((res) => {
            if (res?.payload?.statusCode === 200) {
                toast.success("Location Created Successfully");
                Initialize()
                handleClose();
            } else {
                toast.error(res?.payload?.message || "Something went wrong");
            }
        });
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="border-none justify-content-center">
                <Modal.Title className="mt-3">{selectedLocation?._id ? "Update" : "Add Location"}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <FormikForm>
                        <Modal.Body className="py-0">
                            <div>
                                <Form.Group className="mb-3">
                                    <Form.Label>Location</Form.Label>
                                    <Field
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Enter location name"
                                    />
                                    <ErrorMessage
                                        name="name"
                                        component="div"
                                        className="text-danger"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>City</Form.Label>
                                    <Field
                                        type="text"
                                        name="cityName"
                                        className="form-control"
                                        placeholder="Enter city name"
                                    />
                                    <ErrorMessage
                                        name="cityName"
                                        component="div"
                                        className="text-danger"
                                    />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-none justify-content-center">
                            <button
                                type="button"
                                className="secondary"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                            <button type="submit" className="primary">
                                Add
                            </button>
                        </Modal.Footer>
                    </FormikForm>
                )}
            </Formik>
        </Modal>
    );
};

export default CreateLocationModal;
